/*
 * Copyright Robert Bosch GmbH. Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction, editing, distribution, as well as in the event of applications for industrial property rights.
 */
import React from 'react'
import './style.css'
const Card=({count,status})=>{
return(<>
<div className='card'>
    <p style={{color:status=='Active'||status=='Total'?'green':'red'}} className='count'>{count}</p>
    <p className='status'>{`${status} Users`}</p>
</div>

</>)
}

export default Card